// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__n2Rqp","redUrl":"NotFound_redUrl__pIdS3"};